/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum RuleConditionUsages {
    Restrict = 10,
    Required = 30,
    Disabled = 31,
}
